async function LoginCliente(email, password) {
    // 1. Detectamos el entorno (Local o Producción)
    const isLocal = window.location.hostname === "localhost" || window.location.port === "3000";

    const BASE_URL = isLocal 
        ? 'http://localhost:4000' 
        : 'https://vetladradoc.uy';

    const URL_LOGIN = `${BASE_URL}/api/auth/login`;

    console.log(`%c >>> INTENTANDO LOGIN EN: ${URL_LOGIN} <<< `, 'color: white; background: #2196F3; padding: 3px;');

    try {
        const response = await fetch(URL_LOGIN, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            // CRITICAL: Esto permite que el navegador guarde la cookie de sesión (connect.sid)
            // que envía Passport desde el backend.
            credentials: "include", 
            body: JSON.stringify({
                email: email,
                password: password
            })
        });

        // Retornamos el JSON (que contiene { auth: true, user: {...} } si sale bien)
        return await response.json();

    } catch (error) {
        console.error("Error en la conexión de Login:", error);
        return { 
            success: false, 
            message: "No se pudo conectar con el servidor de autenticación." 
        };
    }
}

export default LoginCliente;